import { makeStyles, theme } from "cdh-data-portal-theme"
import { SIDEBAR_WIDTH } from "../../molecules/Sidebar/Sidebar.static"

export const useStyles = makeStyles()(() => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.colors.globalBackgroundLight,
    marginLeft: SIDEBAR_WIDTH,
    paddingBottom: 42,
    paddingLeft: 42,
    paddingRight: 42,
    paddingTop: 89,
  },
  title: {
    "&&": {
      fontSize: 42,
      fontWeight: 450,
      lineHeight: "68px",
      margin: 0,
    },
  },
  subtitle: {
    "&&": {
      fontSize: 26,
      fontWeight: 400,
      lineHeight: "42px",
      margin: "4px 0 0 0",
    },
  },
  form: {
    background: 'white',
    borderRadius: 8,
    boxShadow: theme.shadows.medium,
    display: "flex",
    flexDirection: "column",
    gap: 20,
    marginTop: 24,
    maxWidth: 860,
    padding: 24,
  },
  fieldRow: {
    display: "grid",
    gap: 24,
    gridTemplateColumns: "minmax(240px, 1fr)",
  },
  feedback: {
    marginTop: 4,
  },
  retryButton: {
    alignSelf: "flex-start",
  },
}))
